// extracted by mini-css-extract-plugin
module.exports = {"paymentRentStatus":"PaymentRentStatusView__paymentRentStatus"};